"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBentleySystems(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm4.09 9.49135c1.0513 0 6.2315.3408 6.3334 1.50419.1637 1.86639-3.5384 2.35768-5.82 2.38-.82 0-2.8459-.2691-2.8459-1.23509 0-.47119.5636-.96529.8972-1.28zm8.75-9.49122h3.16v1.14659a4.83 4.83 0 0 0 -3.16-1.14659zm3.16 3.88577v12.1141h-15.9949l-.0051-1.47589a12.567 12.567 0 0 0 4.4481.8142c4.4168.16349 8.8808-1.26479 8.802-4.39937-.0541-2.15548-4.8511-3.01557-7.7919-3.09487l.2118-.2284c4.9414.1226 9.0209-.58667 10.33-3.72977zm-15.9949 6.65564v-10.54141h8.8485a17.69469 17.69469 0 0 0 -4.2694.85939 17.66379 17.66379 0 0 0 -3.0656 1.25519c-.6847.4185-1.5007 1.11329-1.3201 1.86479.1745.72549 2.2384-.18 3.1217-.437a52.18587 52.18587 0 0 1 7.15-1.41379c2.9741-.1792 3.6924.6067 3.7181 1.1-.0615.7371-1.308 2.13279-7.1028 2.82878 2.1283-2.178 2.3077-2.47 2.4873-2.85118-2.5642 0-3.7483 1.48279-5.415 2.89738a6.67792 6.67792 0 0 0 -3.1129.88109c-.3486.2811-.8464.5443-.5475 1.0363.2146.35469 1.1317.188 1.4443.20769-.7105.82029-1.5361 1.81808-1.9366 2.31277z' })));
}
exports.default = SvgBentleySystems;
